import { ADD_TRAVELER } from "@hopper-b2b/types";
import { trackBaseEvent } from "../utils";

export const trackNewTraveler = async (context) =>
  trackBaseEvent(context, {
    eventName: ADD_TRAVELER,
    properties: {},
  });
